(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motion.matches || !('IntersectionObserver' in window)) return;
  const pending = new Set();
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const node = entry.target;
      node.classList.remove('tw-reveal-pending');
      observer.unobserve(node);
      pending.delete(node);
    }
  }, { rootMargin: '0px 0px -24px 0px', threshold: 0.05 });
  const prepare = () => {
    const main = document.getElementById('MainContent');
    if (!main) return;
    const sections = [...main.querySelectorAll(':scope > .shopify-section')];
    for (const section of sections) {
      if (section.querySelector('.tw-hero, .product-information, product-information, .tw-pdp-hero')) continue;
      const details = section.querySelectorAll('.tw-card, .tw-sock-benefit');
      const targets = details.length ? [section.querySelector('header'), ...details].filter(Boolean) : [section];
      for (const [index, node] of targets.entries()) {
        if (node.dataset.twRevealReady) continue;
        node.dataset.twRevealReady = 'true';
        const bounds = node.getBoundingClientRect();
        if (bounds.top < window.innerHeight || bounds.height === 0) continue;
        node.style.setProperty('--tw-reveal-delay', `${Math.min(index % 3, 2) * 110}ms`);
        node.classList.add('tw-reveal', 'tw-reveal-pending');
        pending.add(node);
        observer.observe(node);
      }
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { once: true });
  else prepare();
  document.addEventListener('shopify:section:load', prepare);
  document.addEventListener('focusin', event => {
    const node = event.target.closest('.tw-reveal-pending');
    if (node) { node.classList.remove('tw-reveal-pending'); observer.unobserve(node); pending.delete(node); }
  });
  motion.addEventListener('change', () => {
    if (!motion.matches) return;
    for (const node of pending) node.classList.remove('tw-reveal-pending');
    pending.clear(); observer.disconnect();
  });
})();
